import { Route, Routes } from "react-router-dom";

import AccountListScreen from "screens/App/CRM/Account/AccountListScreen";
import AccountInfoScreen from "screens/App/CRM/Account/AccountInfoScreen";
import AccountDetailScreen from "screens/App/CRM/Account/AccountDetailScreen";
import AccountEditScreen from "screens/App/CRM/Account/AccountEditScreen";
import AccountCreateScreen from "screens/App/CRM/Account/AccountCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const AccountRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<AccountListScreen />} />

      <Route path="create" element={<AccountCreateScreen />} />

      <Route path=":id/detail" element={<AccountDetailScreen />} />

      <Route path=":id/edit" element={<AccountEditScreen />} />

      <Route path="info" element={<AccountInfoScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default AccountRouter;
